import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import { FormGroup } from '@angular/forms';
import { environment } from 'environment-configurations';
import * as i2 from 'file-upload-library';
import * as i3 from '@angular/common';
import * as i4 from 'primeng/table';
import * as i5 from 'primeng/api';
import * as i6 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class LibResignationSummaryService {
    constructor(http) {
        this.http = http;
        this.onLoadResponseSubject = new BehaviorSubject(null);
    }
    getExitDetails(employeeId) {
        return this.http.get(`/vd/formBuilder/employee/${employeeId}/employeeExitActionDetails`).pipe(map((response) => {
            if (response.status === 200) {
                this.onLoadResponseSubject.next(response);
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
LibResignationSummaryService.ɵfac = function LibResignationSummaryService_Factory(t) { return new (t || LibResignationSummaryService)(i0.ɵɵinject(i1.HttpClient)); };
LibResignationSummaryService.ɵprov = i0.ɵɵdefineInjectable({ token: LibResignationSummaryService, factory: LibResignationSummaryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibResignationSummaryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LibResignationSummaryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵelementStart(2, "h5");
    i0.ɵɵtext(3, "Revoke Request");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵelementStart(5, "div", 3);
    i0.ɵɵtext(6, "Status : ");
    i0.ɵɵelementStart(7, "span", 12);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 7);
    i0.ɵɵelementStart(10, "div", 3);
    i0.ɵɵtext(11, "Revoke Reason");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 4);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate((ctx_r0.exitDetails == null ? null : ctx_r0.exitDetails.status) ? ctx_r0.exitDetails == null ? null : ctx_r0.exitDetails.status : "--");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.exitDetails == null ? null : ctx_r0.exitDetails.revokeSummary);
} }
function LibResignationSummaryComponent_div_28_ng_template_7_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵlistener("click", function LibResignationSummaryComponent_div_28_ng_template_7_div_5_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r9); const loadData_r5 = i0.ɵɵnextContext().$implicit; const ctx_r7 = i0.ɵɵnextContext(2); return ctx_r7.openDoc(loadData_r5); });
    i0.ɵɵelementStart(3, "mat-icon", 23);
    i0.ɵɵtext(4, "visibility");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelementStart(6, "i", 24);
    i0.ɵɵlistener("click", function LibResignationSummaryComponent_div_28_ng_template_7_div_5_Template_i_click_6_listener() { i0.ɵɵrestoreView(_r9); const loadData_r5 = i0.ɵɵnextContext().$implicit; const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.download(loadData_r5); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LibResignationSummaryComponent_div_28_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵelementStart(2, "p", 18);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtemplate(5, LibResignationSummaryComponent_div_28_ng_template_7_div_5_Template, 7, 0, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const loadData_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(loadData_r5 == null ? null : loadData_r5.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", loadData_r5.fileName !== null);
} }
function LibResignationSummaryComponent_div_28_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2, " No records found ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵattribute("colspan", 3);
} }
function LibResignationSummaryComponent_div_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵelementStart(2, "h6");
    i0.ɵɵtext(3, "Uploaded Files");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵelementStart(5, "div", 1);
    i0.ɵɵelementStart(6, "p-table", 15);
    i0.ɵɵtemplate(7, LibResignationSummaryComponent_div_28_ng_template_7_Template, 6, 2, "ng-template", 16);
    i0.ɵɵtemplate(8, LibResignationSummaryComponent_div_28_ng_template_8_Template, 3, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("value", ctx_r1.exitDetails == null ? null : ctx_r1.exitDetails.uploadFiles)("resizableColumns", true);
} }
function LibResignationSummaryComponent_div_29_div_1_tr_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r15 == null ? null : item_r15.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r15 == null ? null : item_r15.email, " ");
} }
function LibResignationSummaryComponent_div_29_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 26);
    i0.ɵɵelementStart(2, "strong");
    i0.ɵɵtext(3, "Notified Stakeholders list");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "table", 27);
    i0.ɵɵelementStart(5, "thead", 28);
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tbody");
    i0.ɵɵtemplate(12, LibResignationSummaryComponent_div_29_div_1_tr_12_Template, 5, 2, "tr", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngForOf", ctx_r13.exitDetails.stakeHolderList);
} }
function LibResignationSummaryComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtemplate(1, LibResignationSummaryComponent_div_29_div_1_Template, 13, 1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.exitDetails == null ? null : ctx_r2.exitDetails.stakeHolderList == null ? null : ctx_r2.exitDetails.stakeHolderList.length) > 0);
} }
class LibResignationSummaryComponent {
    constructor(resignationSummaryService, cdRef, uploadService) {
        this.resignationSummaryService = resignationSummaryService;
        this.cdRef = cdRef;
        this.uploadService = uploadService;
        this.group = new FormGroup({});
        this.exitDetails = [];
        this.observableSubscription$ = new Subject();
        this.showStackHolderSection = false;
    }
    ngOnInit() {
        if ('FbActualEmployeeId' in sessionStorage && parseInt(sessionStorage.getItem('FbActualEmployeeId')) > 0) {
            this.showStackHolderSection = true;
        }
        this.getExitDetails();
        this.resignationSummaryService.onLoadResponseSubject.subscribe(value => {
            this.exitDetails = value;
        });
        this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    }
    getExitDetails() {
        this.employeeId = 'FbActualEmployeeId' in sessionStorage ? parseInt(sessionStorage.getItem('FbActualEmployeeId')) : 'employeeId' in sessionStorage ? parseInt(sessionStorage.getItem('employeeId')) : null;
        if (this.employeeId) {
            this.resignationSummaryService.getExitDetails(this.employeeId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.exitDetails = response.data || null;
                //this..onLoadResponseSubject.next(JSON.parse(formData));    
            });
        }
        this.cdRef.detectChanges();
    }
    openDoc(item) {
        var _a;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl;
        const docPath = (_a = item.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9);
        window.open(`${baseUrl}/${docPath}`, '_blank');
    }
    download(file) {
        var _a, _b, _c;
        //const baseUrl = environment.docs.replace(':5651/docs', '');
        const baseUrl = environment.appUrl + '/';
        this.uploadService.downloadDocuments(baseUrl + ((_a = file.fileLocation) === null || _a === void 0 ? void 0 : _a.substring(9)), this.isFBUser ? (_b = file.fileLocation) === null || _b === void 0 ? void 0 : _b.split('/').slice(-1)[0] : (_c = file.fileLocation) === null || _c === void 0 ? void 0 : _c.substring(9));
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LibResignationSummaryComponent.ɵfac = function LibResignationSummaryComponent_Factory(t) { return new (t || LibResignationSummaryComponent)(i0.ɵɵdirectiveInject(LibResignationSummaryService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.FileUploadLibraryService)); };
LibResignationSummaryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LibResignationSummaryComponent, selectors: [["lib-resignation-summary"]], inputs: { inputParams: "inputParams", inputData: "inputData", group: "group" }, decls: 30, vars: 8, consts: [["class", "row mt-1 ml-2 pl-2 pr-3 pt-3 pb-3 revokeSection", 4, "ngIf"], [1, "row", "mt-2", "p-0", "pb-3"], [1, "col-3"], [1, "labelHeading", "headlbl"], [1, "labelHeading"], [1, "labelHeading", "headlbl", "labelStatusHeading"], [1, "row", "mt-2", "mb-4", "p-0", "pb-3"], [1, "col-12", "mt-2"], [4, "ngIf"], ["class", "row mt-2 mb-4 p-0 pt-4 stackholder_section_divider", 4, "ngIf"], [1, "row", "mt-1", "ml-2", "pl-2", "pr-3", "pt-3", "pb-3", "revokeSection"], [1, "col-12"], [1, "revoke_status"], [1, "col-12", "positionHeading"], [1, "uploadedDocumentSection"], ["styleClass", "p-datatable-gridlines", 3, "value", "resizableColumns"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [1, "label-light"], ["class", "row file-icons", 4, "ngIf"], [1, "row", "file-icons"], [1, "mr-2", "padding0"], [3, "click"], ["matTooltipClass", "tooltip-bg", "matTooltip", "View Document", 1, "material-icons"], ["title", "Download", 1, "fa", "fa-download", "pr-2", "icn", 3, "click"], [1, "row", "mt-2", "mb-4", "p-0", "pt-4", "stackholder_section_divider"], [1, "col-12", "labelHeading", "headlbl"], [1, "col-12", "im-card-no-border-table", "file-upload-list", "table-striped-simple", 2, "margin-top", "20px", "width", "100%"], [2, "height", "30px"], [4, "ngFor", "ngForOf"]], template: function LibResignationSummaryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LibResignationSummaryComponent_div_0_Template, 14, 2, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵtext(4, "Your notice period as per company policy");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 2);
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵtext(9, "Resignation date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 4);
        i0.ɵɵtext(11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 2);
        i0.ɵɵelementStart(13, "div", 3);
        i0.ɵɵtext(14, "Last working date");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 4);
        i0.ɵɵtext(16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 2);
        i0.ɵɵelementStart(18, "div", 5);
        i0.ɵɵtext(19, "Status");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 4);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 6);
        i0.ɵɵelementStart(23, "div", 7);
        i0.ɵɵelementStart(24, "div", 3);
        i0.ɵɵtext(25, "Reason");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 4);
        i0.ɵɵtext(27);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(28, LibResignationSummaryComponent_div_28_Template, 9, 2, "div", 8);
        i0.ɵɵtemplate(29, LibResignationSummaryComponent_div_29_Template, 2, 1, "div", 9);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", (ctx.exitDetails == null ? null : ctx.exitDetails.recentAction) === "Revoke Submitted" || (ctx.exitDetails == null ? null : ctx.exitDetails.recentAction) === "Revoke Approved by HR");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate((ctx.exitDetails == null ? null : ctx.exitDetails.noticePeriod) ? ctx.exitDetails == null ? null : ctx.exitDetails.noticePeriod : "--");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate((ctx.exitDetails == null ? null : ctx.exitDetails.resignationDate) ? ctx.exitDetails == null ? null : ctx.exitDetails.resignationDate : "--");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate((ctx.exitDetails == null ? null : ctx.exitDetails.lastWorkingDate) ? ctx.exitDetails == null ? null : ctx.exitDetails.lastWorkingDate : "--");
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate((ctx.exitDetails == null ? null : ctx.exitDetails.status) ? ctx.exitDetails == null ? null : ctx.exitDetails.status : "--");
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate((ctx.exitDetails == null ? null : ctx.exitDetails.exitSummary) ? ctx.exitDetails == null ? null : ctx.exitDetails.exitSummary : "--");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.exitDetails == null ? null : ctx.exitDetails.uploadFiles == null ? null : ctx.exitDetails.uploadFiles.length) > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showStackHolderSection);
    } }, directives: [i3.NgIf, i4.Table, i5.PrimeTemplate, i6.MatIcon, i3.NgForOf], styles: [".headTbl[_ngcontent-%COMP%]{background-color:#edf4fb;height:40px;padding:10px}.revokeSection[_ngcontent-%COMP%]{background-color:#fff8e5;color:#4a4a4a}.labelHeading[_ngcontent-%COMP%]{font-size:15px}.labelHeading.headlbl[_ngcontent-%COMP%]{font-size:15px;font-weight:400;color:#8d8d8d}.stackholder_section_divider[_ngcontent-%COMP%]{position:relative}.stackholder_section_divider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";width:98%;height:1.5px;margin:0 auto;left:0;right:0;background:#dbe4e7;top:0}.revokeSection[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-weight:800}.revoke_status[_ngcontent-%COMP%]{color:#5099e2}.uploadedDocumentSection[_ngcontent-%COMP%]{position:relative;left:14px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibResignationSummaryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-resignation-summary',
                templateUrl: 'lib-resignation-summary.component.html',
                styleUrls: ['lib-resignation-summary.component.scss']
            }]
    }], function () { return [{ type: LibResignationSummaryService }, { type: i0.ChangeDetectorRef }, { type: i2.FileUploadLibraryService }]; }, { inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class LibResignationSummaryModule {
}
LibResignationSummaryModule.ɵfac = function LibResignationSummaryModule_Factory(t) { return new (t || LibResignationSummaryModule)(); };
LibResignationSummaryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibResignationSummaryModule });
LibResignationSummaryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibResignationSummaryModule, { declarations: [LibResignationSummaryComponent], imports: [PrimengLibraryModule], exports: [LibResignationSummaryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibResignationSummaryModule, [{
        type: NgModule,
        args: [{
                declarations: [LibResignationSummaryComponent],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [LibResignationSummaryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lib-resignation-summary
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LibResignationSummaryComponent, LibResignationSummaryModule, LibResignationSummaryService };
//# sourceMappingURL=lib-resignation-summary.js.map
